/*
  Mublio modal: opent een link met data-mb-modal in een pop-up (iframe) op de site.
  - Gebruikt door snippet mublio-knop als de CTA "Openen als: Modal" heeft.
  - Eén gedeeld <dialog>, pas gebouwd bij de eerste klik. Escape, sluitknop (rechtsboven, over de pagina)
    of klik naast de pop-up sluit. Geen titel of voetbalk: de pagina in de modal heeft zelf een titel.
  - Zonder JavaScript of zonder <dialog>-ondersteuning blijft het een gewone link.
  - Event in dataLayer: mb_modal_open { modal_url }.
*/
(() => {
  if (window.MbModal) return;

  const script = document.currentScript;
  const cssUrl = script && script.dataset.css;
  const sluitIcoon = script && script.dataset.icoonSluit;

  if (cssUrl && !document.querySelector('link[data-mb-modal-css]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssUrl;
    link.dataset.mbModalCss = '';
    document.head.appendChild(link);
  }

  let dialog;
  let frame;
  let huidigeUrl = '';

  const bouw = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'mb-modal';
    if (sluitIcoon) dialog.style.setProperty('--mb-modal-sluit', `url('${sluitIcoon}')`);
    dialog.innerHTML = `
      <button type="button" class="mb-modal__sluit" aria-label="Sluiten"><span aria-hidden="true"></span></button>
      <div class="mb-modal__inhoud">
        <div class="mb-modal__laden" aria-hidden="true"></div>
        <iframe class="mb-modal__frame" title=""></iframe>
      </div>`;
    document.body.appendChild(dialog);

    frame = dialog.querySelector('.mb-modal__frame');

    frame.addEventListener('load', () => {
      if (frame.src && frame.src !== 'about:blank') dialog.classList.add('is-geladen');
    });
    dialog.querySelector('.mb-modal__sluit').addEventListener('click', () => dialog.close());
    // Klik op de donkere achtergrond (buiten de inhoud) sluit
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => document.documentElement.classList.remove('mb-modal-open'));
  };

  const open = (url, tekst) => {
    if (!dialog) bouw();
    // Geen zichtbare titel (de pagina in de modal heeft er zelf een); wel voor schermlezers
    dialog.setAttribute('aria-label', tekst || 'Pop-up');
    frame.title = tekst || 'Pop-up';
    if (url !== huidigeUrl) {
      huidigeUrl = url;
      dialog.classList.remove('is-geladen');
      frame.src = url;
    }
    document.documentElement.classList.add('mb-modal-open');
    dialog.showModal();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'mb_modal_open', modal_url: url });
  };

  document.addEventListener('click', (e) => {
    const knop = e.target.closest('a[data-mb-modal]');
    if (!knop || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (typeof HTMLDialogElement !== 'function') return;
    e.preventDefault();
    open(knop.href, knop.dataset.mbModalTitel || knop.textContent.trim());
  });

  window.MbModal = { open, sluit: () => dialog && dialog.close() };
})();
